import Box from '@mui/material/Box';

type NumenLogoProps = {
    height?: number;
};

export function NumenLogo({ height = 40 }: NumenLogoProps) {
    return <Box component="img" src="/numen-logo.webp" alt="Numen" sx={{ height, width: 'auto', maxWidth: '100%', objectFit: 'contain', display: 'block' }} />;
}
